import { Typography as appTypography } from 'cio-design-library/design-tokens'
import { css, CSSObject } from 'styled-components'

export const FontWeights = {
  Regular: css({ fontWeight: appTypography.weights.regular }),
  Medium: css({ fontWeight: appTypography.weights.medium }),
  DemiBold: css({ fontWeight: appTypography.weights.demibold }),
  Bold: css({ fontWeight: appTypography.weights.bold }),
}

export const Typography = {
  XL: css(appTypography.sizes.XL),
  L: css(appTypography.sizes.L),
  M: css(appTypography.sizes.M),
  S: css(appTypography.sizes.S),
  Subhead: css(appTypography.sizes.Subhead),
  Body: css(appTypography.sizes.Body),
  Caps: css(appTypography.sizes.Caps as CSSObject),
  Caption: css(appTypography.sizes.Caption),
  Tiny: css(appTypography.sizes.Tiny),
  ButtonM: css(appTypography.sizes.ButtonM),
  ButtonS: css(appTypography.sizes.ButtonS),
  ButtonV2M: css(appTypography.sizes.ButtonV2M),
  TextS: css(appTypography.sizes.TextS),
  TextScore: css(appTypography.sizes.TextScore),
}

export default Typography
